var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "ai-summary" }, [
              _c("div", { staticClass: "ai-summary__header" }, [
                _c("img", {
                  attrs: {
                    src:
                      "/ressources/logged/img/illustrations/ai-double-sparkle.svg",
                    width: "40"
                  }
                }),
                _vm._v(" "),
                _c("h2", { staticClass: "ai-summary__title" }, [
                  _vm._v(_vm._s(_vm.$t.__("overview.tabs.TabSummary")))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ai-summary__header-actions" },
                  [
                    _vm.getInProgress
                      ? _c("CompassLoader", {
                          staticClass: "ai-summary__loader",
                          attrs: { size: "large" }
                        })
                      : [
                          !_vm.showFirstTimeContent || _vm.showRemainingQuota
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "ai-summary__generation-information"
                                },
                                [
                                  !_vm.showFirstTimeContent
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "ai-summary__timestamp"
                                        },
                                        [
                                          _c("CompassIcon", {
                                            attrs: {
                                              icon: "clock",
                                              size: "small"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "typographies-paragraph-medium-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t.__(
                                                      "overview.tabs.TabSummary.generationDateTime",
                                                      {
                                                        date: _vm.formattedDate,
                                                        time: _vm.formattedTime
                                                      }
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showRemainingQuota
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ai-summary__remaining-quota",
                                          class: _vm.remainingQuotaClass
                                        },
                                        [
                                          _vm.quotaAILimitReached
                                            ? _c("CompassFeatureBadge", {
                                                attrs: {
                                                  variant: "upsell",
                                                  size: "extra-small"
                                                }
                                              })
                                            : _c("CompassIcon", {
                                                attrs: {
                                                  icon: "ai-icon-write",
                                                  type: "secondary",
                                                  size: "small"
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typographies-paragraph-x-small-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.remainingQuotaLabel
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "CompassTooltip",
                            {
                              attrs: {
                                disabled:
                                  !_vm.disabledGenerationButton ||
                                  _vm.quotaAILimitReached,
                                content: _vm.translations.notEnoughData,
                                arrow: false
                              }
                            },
                            [
                              _c("ButtonAI", {
                                ref: "generateButton",
                                attrs: {
                                  label: _vm.generateButtonLabel,
                                  loading: _vm.isLoading,
                                  disabled:
                                    _vm.disabledGenerationButton &&
                                    !_vm.quotaAILimitReached,
                                  size: "medium",
                                  type: "primary-contrast"
                                },
                                on: { click: _vm.handleGenerate }
                              })
                            ],
                            1
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.getInProgress || _vm.isLoading,
                      expression: "getInProgress || isLoading"
                    }
                  ],
                  staticClass: "ai-summary__loading-animation"
                },
                [
                  _c("div", {
                    ref: "lottie",
                    staticClass: "ai-summary__lottie"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLoading,
                          expression: "isLoading"
                        }
                      ],
                      ref: "loadingMessageRef",
                      staticClass: "ai-summary__loading-animation-word-list"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.loadingMessage) +
                          "\n                "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.getInProgress && !_vm.isLoading
                ? _c("div", { staticClass: "ai-summary__content-wrapper" }, [
                    _vm.showFirstTimeContent
                      ? _c("div", { staticClass: "ai-summary__content" }, [
                          _c("h3", {
                            staticClass:
                              "typographies-display-brand-medium ai-summary__content-title",
                            domProps: {
                              innerHTML: _vm._s(_vm.translations.noData.title)
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "ai-summary__content-description typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.translations.noData.description) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src:
                                "/ressources/logged/img/illustrations/ai-summary-illustration.svg",
                              width: "774"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.showFirstTimeContent && !_vm.isLoading
                      ? _c("div", { staticClass: "ai-summary__content-grid" }, [
                          _c(
                            "div",
                            { staticClass: "ai-summary__content-column" },
                            [
                              _c(
                                "transition",
                                { attrs: { appear: "", name: "slide-up" } },
                                [
                                  _c("SummaryCard", {
                                    staticClass: "ai-summary__card",
                                    attrs: { type: "client" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "transition",
                                { attrs: { appear: "", name: "slide-up" } },
                                [
                                  _c("SummaryCard", {
                                    staticClass: "ai-summary__card",
                                    attrs: { type: "document" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "transition",
                                { attrs: { appear: "", name: "slide-up" } },
                                [
                                  _c("SummaryCard", {
                                    staticClass: "ai-summary__card",
                                    attrs: { type: "sales" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ai-summary__content-column" },
                            [
                              _c(
                                "transition",
                                { attrs: { appear: "", name: "slide-up" } },
                                [
                                  _c("SummaryCard", {
                                    staticClass:
                                      "ai-summary__card-interactions",
                                    attrs: { type: "interactions" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ai-summary__content-column" },
                            [
                              _c(
                                "transition",
                                { attrs: { appear: "", name: "slide-up" } },
                                [
                                  _c("SummaryCard", {
                                    staticClass:
                                      "ai-summary__card-recommendations",
                                    attrs: { type: "recommendations" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showSummary
                ? _c("div", { staticClass: "ai-summary__footer" }, [
                    _c(
                      "div",
                      { staticClass: "ai-summary__feedback" },
                      [
                        _c("CompassIcon", {
                          attrs: {
                            icon: "ai-icon-write",
                            type: "secondary",
                            size: "small"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "ai-summary__feedback-label typographies-paragraph-small-regular"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.translations.generated_by) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("FeedbackPopover", {
                          attrs: {
                            tags: _vm.tags,
                            placement: "top-end",
                            saveOnLike: true
                          },
                          on: {
                            tagSelected: _vm.handleTagSelect,
                            saveFeedback: _vm.handleSaveFeedback
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }